'use strict';

const $ = (s, ctx = document) => ctx.querySelector(s);
const $$ = (s, ctx = document) => [...ctx.querySelectorAll(s)];
const money = (c) => new Intl.NumberFormat('en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(c / 100);

/* ---- Cart API ------------------------------------------- */
let cart = null;
async function fetchCart() { const r = await fetch('/cart.js'); cart = await r.json(); return cart; }
async function addItem(id, qty = 1) {
  const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id, quantity: qty }) });
  if (!r.ok) { const e = await r.json(); throw new Error(e.description || 'Error adding to cart'); }
  return r.json();
}
async function changeItem(line, qty) {
  const r = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity: qty }) });
  cart = await r.json(); return cart;
}

/* ---- Toast ---------------------------------------------- */
let toastTimer;
function toast(msg, dur = 3000) {
  const el = $('#toast'); if (!el) return;
  el.textContent = msg; el.classList.add('toast--visible');
  clearTimeout(toastTimer); toastTimer = setTimeout(() => el.classList.remove('toast--visible'), dur);
}

/* ---- Cart drawer ---------------------------------------- */
function renderCart(c) {
  const body = $('#cart-drawer-body');
  const footer = $('#cart-drawer-footer');
  const count = $('#cart-count');
  const sub = $('#cart-subtotal-price');
  if (count) count.textContent = c.item_count;
  if (!body) return;
  if (c.item_count === 0) { body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty</p>'; if (footer) footer.hidden = true; return; }
  if (footer) footer.hidden = false;
  if (sub) sub.textContent = money(c.total_price);
  body.innerHTML = c.items.map((item, i) => `
    <div class="cart-drawer-item" data-line="${i + 1}">
      ${item.image ? `<img src="${item.image.replace('_200x','_120x')}" class="cart-drawer-item__img" alt="${item.title}" loading="lazy" width="60" height="60">` : '<div class="cart-drawer-item__img"></div>'}
      <div>
        <p class="cart-drawer-item__title">${item.title}</p>
        <div class="cart-drawer-item__meta">
          <span class="cart-drawer-item__price">${money(item.final_price)}</span>
          <button class="cart-drawer-item__remove" data-line="${i + 1}" aria-label="Remove">Remove</button>
        </div>
      </div>
    </div>`).join('');
  body.querySelectorAll('.cart-drawer-item__remove').forEach(btn =>
    btn.addEventListener('click', async () => { const c = await changeItem(+btn.dataset.line, 0); renderCart(c); }));
}
function openCart() {
  const d = $('#cart-drawer'); if (!d) return;
  d.setAttribute('aria-hidden', 'false');
  $('#cart-toggle')?.setAttribute('aria-expanded', 'true');
  document.body.style.overflow = 'hidden';
  fetchCart().then(renderCart);
}
function closeCart() {
  const d = $('#cart-drawer'); if (!d) return;
  d.setAttribute('aria-hidden', 'true');
  $('#cart-toggle')?.setAttribute('aria-expanded', 'false');
  document.body.style.overflow = '';
}
$('#cart-toggle')?.addEventListener('click', () => {
  $('#cart-drawer')?.getAttribute('aria-hidden') === 'false' ? closeCart() : openCart();
});
$('#cart-drawer-close')?.addEventListener('click', closeCart);
$('#cart-drawer .cart-drawer__overlay')?.addEventListener('click', closeCart);
document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeCart(); closeSearch(); } });

/* ---- Product form --------------------------------------- */
const pf = $('#product-form');
if (pf) {
  pf.addEventListener('submit', async e => {
    e.preventDefault();
    const btn = $('#add-to-cart');
    const id = pf.querySelector('[name="id"]')?.value;
    if (!id) return;
    btn.disabled = true;
    const orig = btn.innerHTML;
    btn.innerHTML = '<span class="spin-ring"></span> Adding…';
    try {
      await addItem(+id);
      const c = await fetchCart();
      renderCart(c); openCart(); toast('Added to cart!');
    } catch (err) { toast(err.message, 4000); }
    finally { btn.disabled = false; btn.innerHTML = orig; }
  });
}

/* ---- Buy buttons (cards) -------------------------------- */
document.addEventListener('click', async e => {
  const btn = e.target.closest('.product-card__buy');
  if (!btn) return;
  btn.disabled = true;
  const orig = btn.textContent;
  btn.textContent = '…';
  try {
    await addItem(+btn.dataset.variantId);
    const c = await fetchCart();
    renderCart(c); openCart(); toast('Added to cart!');
  } catch (err) { toast(err.message, 4000); }
  finally { btn.disabled = false; btn.textContent = orig; }
});

/* ---- Gallery thumbs ------------------------------------- */
$$('.gallery-thumb').forEach(t => t.addEventListener('click', () => {
  $$('.gallery-thumb').forEach(x => x.classList.remove('gallery-thumb--active'));
  t.classList.add('gallery-thumb--active');
  const img = $('#product-feat-img');
  if (img) img.src = t.dataset.src;
}));

/* ---- Search --------------------------------------------- */
function openSearch() { const b = $('#search-drawer'); if (!b) return; b.hidden = false; $('#search-toggle')?.setAttribute('aria-expanded','true'); setTimeout(() => $('#search-input')?.focus(), 50); }
function closeSearch() { const b = $('#search-drawer'); if (!b) return; b.hidden = true; $('#search-toggle')?.setAttribute('aria-expanded','false'); }
$('#search-toggle')?.addEventListener('click', () => $('#search-drawer')?.hidden ? openSearch() : closeSearch());
$('#search-close')?.addEventListener('click', closeSearch);

/* ---- Mobile menu ---------------------------------------- */
$('#mobile-menu-toggle')?.addEventListener('click', () => {
  const m = $('#mobile-menu'); const btn = $('#mobile-menu-toggle');
  m.hidden = !m.hidden; btn?.setAttribute('aria-expanded', String(!m.hidden));
});

/* ---- Cart page qty -------------------------------------- */
$$('.qty-btn').forEach(btn => btn.addEventListener('click', async () => {
  const line = +btn.dataset.line;
  const input = $(`.qty-input[data-line="${line}"]`);
  if (!input) return;
  let qty = +input.value;
  qty = btn.dataset.action === 'inc' ? qty + 1 : Math.max(0, qty - 1);
  input.value = qty;
  const c = await changeItem(line, qty);
  const sub = $('#cart-page-subtotal'); if (sub) sub.textContent = money(c.total_price);
  if (qty === 0) location.reload();
}));
$$('.btn-remove').forEach(btn => btn.addEventListener('click', async () => {
  await changeItem(+btn.dataset.line, 0); location.reload();
}));

/* ---- Spin style ----------------------------------------- */
const ss = document.createElement('style');
ss.textContent = `@keyframes spin{to{transform:rotate(360deg)}} .spin{animation:spin .7s linear infinite} .spin-ring{display:inline-block;width:14px;height:14px;border:2px solid rgba(255,255,255,.3);border-top-color:#fff;border-radius:50%;animation:spin .6s linear infinite}`;
document.head.appendChild(ss);

/* ---- Init ----------------------------------------------- */
fetchCart().then(c => { const el = $('#cart-count'); if (el) el.textContent = c.item_count; });
